
import { useParams } from "react-router-dom";
import PopularJobCategoriesList from "./PopularJobCategoriesList";

export function JobByCategoriesPage() {
    const { uuid } = useParams();
    return (
      <div>
        <PopularJobCategoriesList uuid={uuid} />
      </div>
    );
  }